import { Capacitor } from '@capacitor/core';
import { CordovaPlugins } from '../../shared/CordovaPlugins';

export const getAndroidVersion = () => {
    const currentVersionStr = navigator.userAgent.toLowerCase().match(/android (\d+(\.\d{1,2})?)/)?.[1];

    if (!currentVersionStr) {
        return null;
    }

    return Number(currentVersionStr);
};

export const isNative = () => {
    if (isWindows() && window.location.href.includes('index.html')) {
        return true;
    }

    return Capacitor.isNativePlatform();
};

export const isWeb = () => {
    const url = window.location.href;

    if (isWindows() && url.includes('index.html')) {
        return false;
    }

    return !Capacitor.isNativePlatform();
};

export const isConnected = () => {
    if (isWeb()) {
        if (navigator.onLine !== undefined) {
            return navigator.onLine;
        }

        return true;
    }

    return CordovaPlugins().connection.type != 'none';
};

export const isIos = () => {
    if (Capacitor.getPlatform() == 'ios') {
        return true;
    }

    const user_agent = navigator.userAgent.toLowerCase();
    if (user_agent.indexOf('iphone') != -1 || user_agent.indexOf('ipad') != -1 || user_agent.indexOf('ipod') != -1) {
        return true;
    }
    return false;
};

export const isWindows = () => navigator.userAgent.includes('Windows NT');

export const isAndroid = () => {
    if (Capacitor.getPlatform() == 'android') {
        return true;
    }

    if (navigator.userAgent.toLowerCase().indexOf('android') != -1) {
        return true;
    }
    return false;
};

/**
 * Check for login state.  If not required, call success callback after
 * any failures
 */
export const isLoggedIn = (loggedInCallback: () => void, loggedOutCallback: () => void, required: boolean) => {
    $f.mobile.ajax({
        url: '/api/v1/users/is_logged_in_v2/',
        dataType: 'json',
        type: 'GET',
        cache: false,
        success: function (response) {
            if (response.is_authenticated) {
                $f.mobile.settings.update_last_login();
                loggedInCallback();
            } else {
                required ? loggedOutCallback() : loggedInCallback();
            }
        },
        error: function () {
            required ? loggedOutCallback() : loggedInCallback();
        }
    });
};

export const isInIframe = (): boolean => {
    // Mobile app is rendered in an iframe to show a form preview
    return window.location !== window.parent.location;
};
